import { EventAssociatedModel, EventSession } from '~/types/adamTypes';
export const useAppEventSession = () => {
  const sessionStore = useSessionStore();

  const { createEvent } = useAppEvent(
    EventAssociatedModel.Session,
    useConfigStore().appId
  );

  let dateStart = new Date();

  const getTimeSpent = () => {
    return Math.ceil((new Date().getTime() - dateStart.getTime()) / 1000);
  };

  const getEventData = () => {
    const eventData: any = {
      SessionId: sessionStore.id,
    };

    return eventData;
  };
  const start = async () => {
    if (useConfigStore().appId === 'noContentId') return;
    dateStart = new Date();
    const eventData = getEventData();
    await createEvent(EventSession.Start, eventData);
  };
  const stop = async () => {
    if (useConfigStore().appId === 'noContentId') return;
    const eventData = getEventData();
    eventData.TimeSession = getTimeSpent();
    await createEvent(EventSession.Stop, eventData);
  };
  return {
    stop,
    start,
  };
};
